<template>
  <div
    v-show="false"
    class="app-store"
  >
    <div class="image-container">
      <img
        alt="App"
        src="@/assets/images/icons/codesandbox.svg"
      >
    </div>
    <div class="text">
      Upptäck våra appar
    </div>
  </div>
</template>

<script>
export default {
  name: 'MainMenuAppStoreButton',
};
</script>

<style lang="scss" scoped>
  .app-store {
    font-size: 13px;
    border-top: 1px solid $dividerColor;
    display: grid;
    padding: 0 20px;
    grid-template-columns: 65px 1fr;
    align-content: center;
    align-items: center;

    .image-container {
      text-align: center;
    }

    .text {
      padding-left: 10px;
    }
  }
</style>
